import React, {useEffect}  from "react"
import {useSearchParams, useNavigate} from 'react-router-dom';
import TouchpointSelection from "components/SelfCheckin/TouchpointSelection/TouchpointSelection"
import useSelfCheckinNafigation from 'utils/useSelfCheckinNafigation';
import AirlineSelection from "components/SelfCheckin/AirlineSelection/AirlineSelection"
import Passenger from "components/SelfCheckin/Passenger/Passenger"
import ScanPassport from "components/SelfCheckin/ScanPassport/ScanPassport"
import BagsScale from "components/SelfCheckin/BagsScale/BagsScale"
import Printing from "components/SelfCheckin/Printing/Printing"
import ConfirmationMessage from "components/SelfCheckin/ConfirmationMessage/ConfirmationMessage"
import Thanks from "components/SelfCheckin/Thanks/Thanks"

import {
  SelfCheckinStepEnum
} from "components/shared/enums/global-enums.tsx";
import useStore from 'store/store'
import {AppRoutes} from "utils/routes";
import './SelfCheckin.scss'

export default function SelfCheckin(){

  const navigate = useNavigate();
  let [searchParams, ] = useSearchParams();
  let airline = searchParams.get("airline");

  let resetTouchpoint = searchParams.get("resetTouchpoint");

  const storeActions = useStore((state)=> state.actions);
  let activeStep = searchParams.get("activeStep");
  const [redirect, ] = useSelfCheckinNafigation();

  const touchpoint = storeActions.retrieveItem("touchpoint");


  useEffect(()=>{
    
    let TIMEOUT = 60000;
    if (activeStep === SelfCheckinStepEnum.IDLE){
      storeActions.stopScanPassport();
    }
    if (activeStep === SelfCheckinStepEnum.THANKS) TIMEOUT = 25000;
    storeActions.startTimeout(()=>{redirect(-1, SelfCheckinStepEnum.IDLE)}, TIMEOUT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeActions, activeStep]);


  useEffect(()=>{
    storeActions.setLocationId(touchpoint);
  }, [storeActions, touchpoint]);


  useEffect(()=>{
    if (resetTouchpoint) {
      storeActions.storeItem("touchpoint", null);
      navigate(AppRoutes.selfCheckinPath);
    }

  }, [storeActions, resetTouchpoint, navigate]);


  let step;

  airline = airline || "sita";

  if(!activeStep || activeStep  === SelfCheckinStepEnum.AIRLINE_SELECTION){
    step = <AirlineSelection />;

  }else if(activeStep === SelfCheckinStepEnum.SCAN_PASSPORT){
    step = <ScanPassport airline={airline}/>;

  }else if(activeStep === SelfCheckinStepEnum.PASSENGER){
    step = <Passenger airline={airline} typeFor={SelfCheckinStepEnum.PASSENGER}/>;

  }else if(activeStep === SelfCheckinStepEnum.DANGEROUS_GOODS){
    step = <ConfirmationMessage airline={airline} />;

  }else if(activeStep === SelfCheckinStepEnum.BAGS_SCALE){
    step = <BagsScale airline={airline} />;

  }else if(activeStep === SelfCheckinStepEnum.ITEMS_TO_PRINT){
    step = <Passenger airline={airline} typeFor={SelfCheckinStepEnum.ITEMS_TO_PRINT} />;

  }else if(activeStep === SelfCheckinStepEnum.PRINTING){
    step = <Printing airline={airline} />;

  }else if(activeStep === SelfCheckinStepEnum.THANKS){
    step = <Thanks airline={airline}/>;
  }


  return (
    <div className="self-checkin">

      {
        !touchpoint ? (<TouchpointSelection/> ): (step)
      }
      
    </div>
    )
}